import {remCalc} from '../../_utils'
import {StyleFunctionProps} from '@chakra-ui/theme-tools'

/**
 * the feedback style
 */

export default {
    baseStyle: {
        container: {
            width: remCalc(342),
            minWidth: remCalc(342),
            minHeight: remCalc(72),
            padding: remCalc(24),
            gap: remCalc(23),
            color: 'text.success',
            textStyle: 'body-medium',
            bg: 'grey',
        },
        statusIcon: {
            width: 'iconsSize.medium',
            height: 'iconsSize.medium',
        },
        closeIcon: {
            width: 'iconsSize.medium',
            height: 'iconsSize.medium',
            color: 'background.dark',
            p: remCalc(3),
        },
    },
    variants: {
        guestWishlistFeedback: {
            container: {
                display: 'flex',
                height: 'auto',
                bg: 'background.default',
                color: 'text.default',
                borderRadius: ['large.base', 'large.sm', 'large.md', 'large.lg'],
                border: 'small',
                borderStyle: 'solid',
                borderColor: 'border.light',
                width: {base: '100%', md: remCalc(451)},
                padding: remCalc(26),
                flexDirection: 'column',
                alignItems: 'flex-start',
                gap: remCalc(22),
                textStyle: 'body-small',
            },
            statusIcon: {
                color: 'text.success',
            },
            closeIcon: {
                display: 'none',
            },
        },
        wishlistFeedback: {
            container: {
                bg: 'background.default',
                color: 'text.default',
                borderRadius: ['large.base', 'large.sm', 'large.md', 'large.lg'],
                border: 'small',
                borderStyle: 'solid',
                borderColor: 'border.light',
                textStyle: 'body-small',
                width: {base: '100%', md: remCalc(451)},
                padding: remCalc(26),
            },
            statusIcon: {
                color: 'text.success',
            },
            closeIcon: {
                width: 'iconsSize.medium',
                height: 'iconsSize.medium',
                color: 'background.dark',
            },
        },
        removeFeedback: {
            container: {
                color: 'text.secondary',
                textStyle: 'body-small',
                fontWeight: 400,
                w: '100%',
                h: 'auto',
                maxHeight: remCalc(92),
                bg: 'background.success',
            },
        },
        vatWarning: {
            container: {
                display: 'flex',
                minWidth: remCalc(343),
                padding: remCalc(26),
                flexDir: 'column',
                alignItems: 'flex-start',
                gap: remCalc(22),
                alignSelf: 'stretch',
                bg: 'background.light',
                color: 'text.default',
                w: '100%',
                h: 'auto',
                textStyle: 'body-small',
                fontWeight: 400,
            },
            innerContainer: {
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                alignContent: 'flex-start',
                rowGap: remCalc(13),
                alignSelf: 'stretch',
                flexWrap: 'wrap',
            },
        },
        removeFeedbackWishlist: {
            container: {
                color: 'text.secondary',
                textStyle: 'body-small',
                fontWeight: 400,
                w: '100%',
                h: 'auto',
                maxHeight: remCalc(92),
                bg: 'background.success',
            },
        },
        freeItemPromo: {
            container: {
                display: 'flex',
                flexDir: 'column',
                color: 'text.secondary',
                textStyle: 'body-small',
                fontWeight: 400,
                w: '100%',
                h: 'auto',
                padding: 'small.base',
                maxHeight: remCalc(120),
                bg: 'background.info',
                gap: 'small.base',
                borderRadius: 'large.base',
                minWidth: remCalc(200),
            },
        },
        default: (props: StyleFunctionProps) => {
            return {
                container: {
                    bg: `${
                        props.status === 'success' ? 'background.success' : 'background.danger'
                    }`,
                    color: `${props.status === 'success' ? 'text.success' : 'text.danger'}`,
                },
            }
        },
    },
    defaultProps: {
        variant: 'default',
    },

    parts: ['container', 'statusIcon', 'closeIcon'],
}
